export const buildCircuitSavePayload = (
  allCircuits,
  updatedCircuits,
  formData,
  diversityGroups,
  structureId,
) => {
  if (!Array.isArray(updatedCircuits)) return [];

  const resolve = (list, value, key = "name") => {
    if (!value || !Array.isArray(list)) return null;
    const firstItem = list[0];

    if (typeof firstItem === "string") {
      return list.includes(value) ? value : null;
    }

    const found = list.find((i) => i[key] === value);
    return found ? { ...found } : null;
  };

  const toNumeric = (value) => {
    if (value === null || value === undefined || value === "") return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const toKilobits = (converted, raw, unit) => {
    const convertedValue = toNumeric(converted);
    const rawValue = toNumeric(raw);

    if (unit === "Gbps") {
      return convertedValue !== null ? convertedValue * 1000 * 1000 : rawValue;
    }

    if (unit === "Mbps") {
      return convertedValue !== null ? convertedValue * 1000 : rawValue;
    }

    if (unit === "Kbps") {
      return convertedValue ?? rawValue;
    }

    return rawValue ?? (convertedValue !== null ? convertedValue * 1000 : null);
  };

  return updatedCircuits.map(({ circuitId, fields }) => {
    const originalCircuit = allCircuits.find(
      (c) => c.circuitGmId === Number(circuitId),
    );

    const isNew = !originalCircuit;

    const merged = {
      ...(originalCircuit ?? {}),
      ...fields,
    };

    const portBandwidthUnit = merged.portBandwidthUnit ?? "Mbps";
    const accessBandwidthUnit = merged.accessBandwidthUnit ?? "Mbps";

    const portBandwidthKb = toKilobits(
      merged.portBandwidthConverted,
      merged.portBandwidth,
      portBandwidthUnit,
    );

    const accessBandwidthKb = toKilobits(
      merged.accessBandwidthConverted,
      merged.accessBandwidth,
      accessBandwidthUnit,
    );

    const circuitDiversityGroups = isNew
      ? []
      : (diversityGroups
          ?.filter((group) =>
            group?.circuits?.some(
              (c) => c?.circuitGmId === originalCircuit.circuitGmId,
            ),
          )
          .map((g) => ({ id: g.id })) ?? []);

    return {
      circuitGmId: isNew ? null : originalCircuit.circuitGmId,
      structureId,

      circuitVendorId: merged.circuitVendorId,
      status: resolve(formData.status, merged.status),
      use: resolve(formData.use, merged.use),
      type: resolve(formData.type, merged.type),
      category: resolve(formData.category, merged.category),

      carrier: resolve(formData.carrier, merged.carrier, "carrierName"),
      lec: resolve(formData.carrier, merged.lec, "carrierName"),

      handoffType: resolve(formData.handoffType, merged.handoffType),
      redundancyType: resolve(formData.redundancyType, merged.redundancyType),
      scope: resolve(formData.scope, merged.scope),

      mrcBaseline: merged.mrcBaseline,
      portBandwidth: portBandwidthKb,
      portBandwidthUnit,
      accessBandwidth: accessBandwidthKb,
      accessBandwidthUnit,
      vcBandwidth: merged.vcBandwidth,

      currency: resolve(formData.iosCurrency, merged.currency),
      billToCountry: resolve(formData.countries, merged.billToCountry),

      cutoverDate: merged.cutoverDate,
      forecastDeliveryDate: merged.forecastDeliveryDate,
      actualHandoverDate: merged.actualHandoverDate,
      currentTermEndDate: merged.currentTermEndDate,
      actualBillingStartDate: merged.actualBillingStartDate,
      actualBillingStopDate: merged.actualBillingStopDate,
      requestedDisconnectDate: merged.requestedDisconnectDate,

      diversePop: merged.diversePop,
      diversePhysicalPath: merged.diversePhysicalPath,

      circuitNote: merged.circuitNote?.replace(/\\n/g, "\n") ?? "",

      diversityGroups: circuitDiversityGroups,
    };
  });
};
